<template>
  <div>
    <v-card>
      <v-card-title>{{ $t("forms.title") }}</v-card-title>
      <v-card-text>
        <v-list>
          <v-list-item :to="`/softwares/${software.id}/forms/modifySoftwareForm`">
            <v-list-item-icon><v-icon>mdi-pencil</v-icon></v-list-item-icon>
            {{ $t("software.forms.modifySoftware") }}
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>

    <v-card class="mt-4 pa-6">
      <SoftwareFields
        :software="software"
        :editor-ready="loaded"
        readonly
      />
      <div class="text-center mt-6">
        <v-btn text @click="$router.go(-1)">
          <v-icon left>mdi-arrow-left</v-icon>{{ $t("button.back") }}
        </v-btn>
        <DeleteObjectForm
          url-objects="software"
          object_type="software"
          :headers="headers"
          :item="software"
        />
      </div>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import DeleteObjectForm from "@/components/delete_object/DeleteObjectForm";
import SoftwareFields from "./SoftwareFields.vue";
import { createDefaultSoftware, normalizeSoftware } from "@/utils/software";

export default {
  name: "DetailSoftware",
  components: { DeleteObjectForm, SoftwareFields },
  data: () => ({
    software: createDefaultSoftware(),
    loaded: false
  }),
  computed: {
    headers() {
      return [{ text: this.$t("form.name"), value: "name" }];
    }
  },
  created() {
    axios
      .get(`${this.$store.state.endpoint}/user/software/${this.$route.params.id}`)
      .then(response => {
        this.software = normalizeSoftware(response.data);
        this.$store.state.sectionTitle = this.software.name;
      })
      .catch(error => console.error(error))
      .finally(() => {
        this.loaded = true;
      });
  }
};
</script>
